import React, { useEffect, useState, useRef } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Typography,
  Button,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  RadioGroup,
  FormControl,
  Grid,
  Radio,
  Switch,
  TextField,
  Chip,
  Tooltip,
  Autocomplete,
} from "@mui/material";
import { getData, postData, postFormData } from "../../../ServerRequest";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CancelIcon from "@mui/icons-material/Cancel";
import InfoIcon from "@mui/icons-material/Info";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import IconButton from "@mui/material/IconButton";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddFabricTag from "./AddFabricTag";

export default function DetailDropdowns() {
  const searchParams = new URLSearchParams(window.location.search);
  const productId = searchParams.get("product_id");
  const [loading, setLoading] = useState(true);
  //const [selectedImage, setSelectedImage] = useState("");
  //const [open, setOpen] = useState(false);
  //const [editingImageUrl, setEditingImageUrl] = useState("");
  //const [isEditing, setIsEditing] = useState(false);
  //const [images, setImages] = useState([]);
  const [ps_product_ID, setPsProductID] = useState("");
  const [ps_product_productcode, setPsProductProductcode] = useState("");
  const [ps_product_cat, setPsProductCat] = useState("");
  const [ps_product_productdesc, setPsProductProductdesc] = useState("");
  const [ps_product_productimg, setPsProductProductimg] = useState("");
  const [ps_product_prodwho, setPsProductProdwho] = useState("");
  const [ps_product_prodname, setPsProductProdname] = useState("");
  const [ps_product_desc, setPsProductDesc] = useState("");
  const [ps_product_sellrate1, setPsProductSellrate1] = useState("");
  const [ps_product_sellrate2, setPsProductSellrate2] = useState("");
  const [ps_product_sellrate3, setPsProductSellrate3] = useState("");
  const [ps_product_subcat, setPsProductSubcat] = useState("");
  const [ps_product_mill, setPsProductMill] = useState("");
  const [ps_product_count, setPsProductCount] = useState("");
  const [ps_product_composition, setPsProductComposition] = useState("");
  const [ps_product_size, setPsProductSize] = useState("");
  const [ps_product_construction, setPsProductConstruction] = useState("");
  const [ps_product_width, setPsProductWidth] = useState("");
  const [ps_product_style, setPsProductStyle] = useState("");
  const [ps_product_quality, setPsProductQuality] = useState("");
  const [ps_product_type, setPsProductType] = useState("");
  const [ps_product_pattern, setPsProductPattern] = useState("");
  const [ps_product_shade, setPsProductShade] = useState("");
  const [ps_product_color1, setPsProductColor1] = useState("");
  const [ps_product_color2, setPsProductColor2] = useState("");
  const [ps_product_color3, setPsProductColor3] = useState("");
  const [ps_product_color4, setPsProductColor4] = useState("");
  const [ps_product_color5, setPsProductColor5] = useState("");
  const [ps_product_purchaserate1, setPsProductPurchaserate1] = useState("");
  const [ps_product_purchaserate2, setPsProductPurchaserate2] = useState("");
  const [ps_product_purchaserate3, setPsProductPurchaserate3] = useState("");
  const [ps_product_createdttime, setPsProductCreatedttime] = useState("");
  const [ps_product_modifydttime, setPsProductModifydttime] = useState("");
  const [ps_product_QQH, setPsProductQQH] = useState("");
  const [ps_product_SO, setPsProductSO] = useState("");
  const [ps_product_IQ, setPsProductIQ] = useState("");
  const [ps_product_DC, setPsProductDC] = useState("");
  const [ps_product_DCvalue, setPsProductDCvalue] = useState("");
  const [ps_product_DCqty, setPsProductDCqty] = useState("");
  const [ps_product_rcptqty, setPsProductRcptqty] = useState("");
  const [ps_product_issueqty, setPsProductIssueqty] = useState("");
  const [ps_product_lastsellrate, setPsProductLastsellrate] = useState("");
  const [ps_product_COMM, setPsProductCOMM] = useState("");
  const [ps_product_netqty, setPsProductNetqty] = useState("");
  const [ps_product_dim1, setPsProductDim1] = useState("");
  const [ps_product_dim2, setPsProductDim2] = useState("");
  const [ps_product_dim3, setPsProductDim3] = useState("");
  const [ps_product_dim4, setPsProductDim4] = useState("");
  const [ps_product_dim5, setPsProductDim5] = useState("");
  const [ps_product_instock, setPsProductInstock] = useState("");
  const [ps_product_likes, setPsProductLikes] = useState("");
  const [ps_product_tags, setPsProductTags] = useState("");
  const [ps_product_tags2, setPsProductTags2] = useState("");
  const [ps_product_excelpath, setPsProductExcelpath] = useState("");
  const [ps_product_isimgdone, setPsProductIsimgdone] = useState("");
  const [ps_product_tags3, setPsProductTags3] = useState("");
  const indianStates = [
                "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
                "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
                "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya",
                "Mizoram", "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim",
                "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand",
                "West Bengal", "Andaman and Nicobar Islands", "Chandigarh", "Dadra and Nagar Haveli and Daman and Diu",
                "Delhi", "Jammu and Kashmir", "Ladakh", "Lakshadweep", "Puducherry"
              ];
  // Additional model variables
  const [product_code, setProductCode] = useState("");
  const [productDetailId, setProductDetailId] = useState(0);
  const [is_nos, setIsNos] = useState(false);
  const [denim, setDenim] = useState(false);
  const [minimum_order, setMinimumOrder] = useState("");
  const [tag_ids, setTagIds] = useState([]);
  const [fabric_specification, setFabricSpecification] = useState("");
  const [delivery_return_policy, setDeliveryReturnPolicy] = useState({
    policy_type: "manual",
    shipping_details: "",
    return_policy: "",
  });
  const [product_description, setProductDescription] = useState("");
  const [product_title, setProductTitle] = useState("");
  const [febricWeave, setFebricWeave] = useState("");
  const [patternSize, setPatternSize] = useState("medium");

  const [excludedTerritories, setExcludedTerritories] = useState([]);
  const [includePincodes, setIncludePincodes] = useState([]);
  const [excludePincodes, setExcludePincodes] = useState([]);
  const [inputValues, setInputValues] = useState({
    excluded: "",
    include: "",
    exclude: "",
  });
  const [isSpecChecked, setIsSpecChecked] = useState(false);
  const [fabricSpec, setFabricSpec] = useState("");
  const [editedSpec, setEditedSpec] = useState(fabricSpec);

  const [manufacturingDetails, setManufacturingDetails] = useState("");
  const [editedManufacturing, setEditedManufacturing] = useState(manufacturingDetails);

  const [isTestChecked, setIsTestChecked] = useState(false);
  const [reports, setReports] = useState([
    { id: 1, name: "Report 1", file: null },
    { id: 2, name: "Report 2", file: null },
    { id: 3, name: "Report 3", file: null },
  ]);

  // Meta tags & description
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [isEditingDescription, setIsEditingDescription] = useState(false);
  const [titleTag, setTitleTag] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [classificationList, setClassificationList] = useState([]);
  const [weaveList, setWeaveList] = useState([]);
  const [isStocked, setIsStocked] = useState(false);
  const [fabricWeave, setFabricWeave] = useState("");
  const [minOrderQty, setMinOrderQty] = useState("10");
  const [isCotton, setIsCotton] = useState(false);

  const [savedFabricSpec, setSavedFabricSpec] = useState("");
  const [savedManufacturingDetails, setSavedManufacturingDetails] =
    useState("");
  const [savedTitleTag, setSavedTitleTag] = useState("");
  const [savedMetaDescription, setSavedMetaDescription] = useState("");
  const [isGeneratingMeta, setIsGeneratingMeta] = useState(false);
  const [similarProducts, setSimilarProducts] = useState([]);
  const [allProducts, setAllProducts] = useState([]);

  // Add saved state for each section
  const [isFabricDetailsSaved, setIsFabricDetailsSaved] = useState(false);
  const [isFabricSpecSaved, setIsFabricSpecSaved] = useState(false);
  const [isManufacturingDetailsSaved, setIsManufacturingDetailsSaved] = useState(false);
  const [isSimilarProductsSaved, setIsSimilarProductsSaved] = useState(false);
  const [isTestReportSaved, setIsTestReportSaved] = useState(false);
  const [isDeliveryPolicySaved, setIsDeliveryPolicySaved] = useState(false);
  const [isDeliveryDetailsSaved, setIsDeliveryDetailsSaved] = useState(false);
  const [isMetaTagsSaved, setIsMetaTagsSaved] = useState(false);
  const [territoryInputs, setTerritoryInputs] = useState([
    { id: 1, value: "", pincodeRange: "" }
  ]);
  const [addTerritoryError, setAddTerritoryError] = useState("");

  const generateProductDetailId = () => {
    return Math.floor(Math.random() * 9) + 1;
  };

  const fetchMetaTags = async () => {
    try {
      setIsGeneratingMeta(true);

      // Get product data to get saved tag IDs
      const productResponse = await getData("/api/product/get-product?product_id=" + productId);
      console.log("Product Response:", productResponse);

      if (!productResponse.data || !productResponse.data.acc_product_details) {
        alert("No product data found.");
        setIsGeneratingMeta(false);
        return;
      }

      const productDetails = productResponse.data.acc_product_details;
      const tagIds = productDetails.tag_ids || [];
      console.log("Tag IDs:", tagIds);

      // Get all fabric tags to map IDs to names
      const fabricTagsResponse = await getData("/api/product/get-fabric-tags-admin");
      console.log("Fabric Tags Response:", fabricTagsResponse);

      if (!fabricTagsResponse.data || !fabricTagsResponse.data.fabric_tags) {
        alert("No fabric tags found.");
        setIsGeneratingMeta(false);
        return;
      }

      // Flatten the nested fabric tags structure
      const allFabricTags = Object.values(fabricTagsResponse.data.fabric_tags)
        .flat()
        .filter((tag) => tag && tag.id && tag.product_tag);

      console.log("Flattened Fabric Tags:", allFabricTags);

      // Map tag IDs to tag names
      let allTags = [];

      // Add Fabric Composition tags with percentages
      if (productDetails.blend_percentages) {
        const blendPercentages = JSON.parse(productDetails.blend_percentages);
        for (const [tagName, percentage] of Object.entries(blendPercentages)) {
          allTags.push(`${tagName} ${percentage}%`);
        }
      }

      // Add all other tags by mapping IDs to names
      tagIds.forEach((tagId) => {
        const tag = allFabricTags.find((t) => t.id === tagId);
        if (tag && tag.product_tag && !allTags.includes(tag.product_tag)) {
          allTags.push(tag.product_tag);
        }
      });

      console.log("Final Tags:", allTags);

      if (allTags.length === 0) {
        alert("No tags found. Please add tags first.");
        setIsGeneratingMeta(false);
        return;
      }

      const metaData = {
        product_id: productId,
        generate_type: "both",
        input_text: allTags.join(", "),
      };
      console.log("Sending metadata:", metaData);

      const res = await postData("/api/product/get-product-meta/", metaData);
      console.log("API Response:", res);

      if (res.data && res.data.data) {
        const responseData = res.data.data;
        // console.log('Processing response data:', responseData);

        const title = (responseData.product_title || "").replace(/\"|\([^)]*\)/g, "").trim();
        const description = (responseData.product_description || "").replace(/\"|\([^)]*\)/g, "").trim();
        // console.log('Processed title:', title);
        // console.log('Processed description:', description);

        setTitleTag(title);
        setMetaDescription(description);
        setSavedTitleTag(title);
        setSavedMetaDescription(description);
        setDeliveryReturnPolicy({
          policy_type: responseData.return_policy?.policy_type || "manual",
          shipping_details: responseData.return_policy?.shipping_details || "",
          return_policy: responseData.return_policy?.return_policy || "",
        });
      } else {
        console.error("Invalid response structure:", res);
        throw new Error("Invalid response structure from API");
      }
    } catch (error) {
      console.error("Error generating meta tags:", error);
      alert(error.message);
    } finally {
      setIsGeneratingMeta(false);
    }
  };

  const handleMetaTagsSubmit = async (event) => {
    event.preventDefault && event.preventDefault();
    setLoading(true);
    try {
      // Use the correct productDetailId from state, do not generate random
      if (!productDetailId || productDetailId === 0) {
        alert("Error: productDetailId is missing or invalid.");
        setLoading(false);
        return;
      }
      const metaTagsData = {
        'id': productDetailId,
        'product_id': productId,
        'product_title': titleTag,
        'product_description': metaDescription,
      };
      const res = await postData("/api/product/save-product-meta/", metaTagsData);
      if (res["data"] && res["data"]["code"] === "200") {
        setSavedTitleTag(titleTag);
        setSavedMetaDescription(metaDescription);
        setIsMetaTagsSaved(true);
        alert("Meta tags and description updated successfully");
        // Refresh meta tags from backend after save
        await fetchMetaTags();
      } else {
        setIsMetaTagsSaved(false);
        alert("Failed to update meta tags and description");
        console.error("Failed to update meta tags:", res.statusText);
      }
    } catch (error) {
      setIsMetaTagsSaved(false);
      alert("Error updating meta tags: " + error.message);
      console.error("Error updating meta tags:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    let productReqData = {
      'id': productDetailId,
      'product_id': ps_product_ID,
      'product_code': ps_product_productcode,
      'fabric_weave': fabricWeave,
      'is_nos': is_nos,
      'denim': denim,
      'minimum_order': minOrderQty,
      //'tag_ids': tag_ids,
      //'fabric_specification': fabric_specification,
      //'manufacturing_details': manufacturingDetails,
      //'delivery_return_policy': delivery_return_policy,
      //'product_description': product_description,
      //'product_title': product_title,
    };

    try {
      console.log(productReqData);
      const res = await postData("/api/product/save-fabric-details", productReqData);
      console.log(res);
      if (res["data"]["code"] === "200") {
        setLoading(false);
        alert("Fabric details updated successfully");
        setIsFabricDetailsSaved(true);
      } else {
        alert("Fabric details update failed");
        setIsFabricDetailsSaved(false);
        console.error("Failed to submit form:", res.statusText);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setLoading(false);
      setIsFabricDetailsSaved(false);
    }
  };

  const handleFabricSpecSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    const detailId = productDetailId || generateProductDetailId();

    let fabricSpecData = {
      'id': detailId,
      'product_code': productId,
      'fabric_specification': editedSpec,
    };

    try {
      console.log(fabricSpecData);
      const res = await postData("/api/product/save-fabric-specification?product_id=" + productId, fabricSpecData);
      console.log(res);
      if (res["data"]["code"] === "200") {
        setSavedFabricSpec(editedSpec);
        setProductDetailId(detailId);
        setLoading(false);
        alert("Fabric specification updated successfully");
        setIsFabricSpecSaved(true);
      } else {
        alert("Fabric specification update failed");
        setIsFabricSpecSaved(false);
        console.error("Failed to submit form:", res.statusText);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setLoading(false);
      setIsFabricSpecSaved(false);
    }
  };

  const handleManufacturingDetailsSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    const detailId = productDetailId || generateProductDetailId();

    let manufacturingDetailsData = {
      'id': detailId,
      'product_code': productId,
      'manufacturing_details': manufacturingDetails,
    };

    try {
      console.log(manufacturingDetailsData);
      const res = await postData("/api/product/save-manufacturing-details?product_id=" + productId, manufacturingDetailsData);
      console.log(res);
      if (res["data"]["code"] === "200") {
        setSavedManufacturingDetails(manufacturingDetails);
        setLoading(false);
        alert("Manufacturing details updated successfully");
        setIsManufacturingDetailsSaved(true);
        //window.location.reload();
      } else {
        alert("Manufacturing details update failed");
        setIsManufacturingDetailsSaved(false);
        console.error("Failed to submit form:", res.statusText);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setLoading(false);
      setIsManufacturingDetailsSaved(false);
    }
  };

  const handleTestReportSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const reportsToSubmit = reports.filter((report) => report.file);

      if (reportsToSubmit.length === 0) {
        alert("No files to update.");
        setLoading(false);
        return;
      }

      // Create a FormData object
      const formData = new FormData();
      await formData.append("product_id", productId);
      reportsToSubmit.forEach((report, index) => {
        formData.append("reports", report.file, `${productId}_${index + 1}`);
      });
      // Debug: Print FormData contents
      for (let pair of formData.entries()) {
        console.log('FormData:', pair[0], pair[1]);
      }
      // Send the FormData object using postFormData
      const res = await postFormData("/api/product/save-test-report", formData);
      console.log("API response:", res);

      if (res.data.code !== "200") {
        throw new Error("Failed to update report: " + res.statusText);
      }

      setLoading(false);
      alert("Test reports updated successfully");
      setIsTestReportSaved(true);

      // Update the reports state to mark them as saved
      setReports((prev) =>
        prev.map((report) => ({
          ...report,
          isNewUpload: false,
        }))
      );
    } catch (error) {
      console.error("Error submitting reports:", error);
      setLoading(false);
      alert("Test report update failed");
      setIsTestReportSaved(false);
    }
  };

  const handleDeliveryPolicySubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    const detailId = productDetailId || generateProductDetailId();

    let deliveryPolicyData = {
      'id': detailId,
      'product_code': productId,
      'policy_type': delivery_return_policy.policy_type,
      'shipping_details': delivery_return_policy.shipping_details,
      'return_policy': delivery_return_policy.return_policy,
    };

    try {
      const res = await postData("/api/product/save-delivery-policy?product_id=" + productId, deliveryPolicyData);
      if (res.data.code === "200") {
        setLoading(false);
        alert("Policy updated successfully");
        setIsDeliveryPolicySaved(true);
        const updated = res.data.updated_policy || {};
        setDeliveryReturnPolicy({
          policy_type: updated.policy_type || "manual",
          shipping_details: updated.shipping_details || "",
          return_policy: updated.return_policy || "",
        });
        // Re-fetch product data to update UI
        fetchformData();
      } else {
        alert("Policy update failed");
        setIsDeliveryPolicySaved(false);
        console.error("Failed to submit form:", res.statusText);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setLoading(false);
      setIsDeliveryPolicySaved(false);
    }
  };

  const handleDeliveryDetailsSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    const detailId = productDetailId || generateProductDetailId();

    const deliveryDetailsData = {
      'id': detailId,
      'product_id': ps_product_ID,
      'area': excludedTerritories,
      'included_pincodes': includePincodes,
      'excluded_pincodes': excludePincodes,
    };

    try {
      console.log(deliveryDetailsData);
      const res = await postData("/api/product/delivery-territory", deliveryDetailsData);
      console.log(res);
      if (res["data"]["code"] === "200") {
        setLoading(false);
        alert("Delivery details updated successfully");
        setIsDeliveryDetailsSaved(true);
        // Re-fetch product data to update UI
        fetchformData();
      } else {
        alert("Delivery details update failed");
        setIsDeliveryDetailsSaved(false);
        console.error("Failed to submit form:", res.statusText);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setLoading(false);
      setIsDeliveryDetailsSaved(false);
    }
  };

  const handleSyncMeta = async () => {
    try {
      setIsGeneratingMeta(true);
      // Trigger backend meta generation
      await postData("/api/product/save-product-meta/", {
        'product_id': productId,
      });
      // Refetch product details
      const productResponse = await getData(
        "/api/product/get-product?product_id=" + productId
      );
      if (productResponse.data && productResponse.data.acc_product_details) {
        const productDetails = productResponse.data.acc_product_details;
        setTitleTag(productDetails.product_title || "");
        setMetaDescription(productDetails.product_description || "");
        setSavedTitleTag(productDetails.product_title || "");
        setSavedMetaDescription(productDetails.product_description || "");
        setIsMetaTagsSaved(true); // Show check icon after successful sync
      } else {
        setIsMetaTagsSaved(false);
      }
    } catch (error) {
      alert("Failed to sync meta tags: " + error.message);
      setIsMetaTagsSaved(false);
    } finally {
      setIsGeneratingMeta(false);
    }
  };

  // Move fetchformData outside useEffect so it can be called after saves
  async function fetchformData() {
    let resData = await getData("/api/product/get-product?product_id=" + productId);
    let territoryData = await getData("/api/product/delivery-territory?product_id=" + productId);
    console.log(resData);
    console.log(territoryData);
    if(territoryData['data']['territories']){
      territoryData = territoryData['data']['territories'];
    }
    let product_data = resData["data"]["product"];
    let product_details_data = resData["data"]["acc_product_details"];
    let product_testing_reports = resData["data"]["testing_reports"];
    if (product_data) {
      console.log(product_data);
      console.log(product_details_data);

      if (product_details_data && product_details_data.fabric_specification) {
        setSavedFabricSpec(product_details_data.fabric_specification);
        setEditedSpec(product_details_data.fabric_specification);
      } else if (product_details_data.fabric_specification) {
        setSavedFabricSpec(product_details_data.fabric_specification);
        setEditedSpec(product_details_data.fabric_specification);
      }

      if (product_details_data && product_details_data.manufacturing_details) {
        setSavedManufacturingDetails(product_details_data.manufacturing_details);
        setManufacturingDetails(product_details_data.manufacturing_details);
      } else if (product_data.manufacturing_details) {
        setSavedManufacturingDetails(product_data.manufacturing_details);
        setManufacturingDetails(product_data.manufacturing_details);
      }

      if (product_testing_reports && product_testing_reports.length > 0) {
        const reportsFromDB = product_testing_reports.map((report) => ({
          ...report,
          isNewUpload: false, 
        }));
        setReports(reportsFromDB);
      }

      const deliveryPolicy = product_data.return_policy || {};
      setDeliveryReturnPolicy({
        policy_type: product_details_data.policy_type || "manual",
        shipping_details: product_details_data.shipping_details || "",
        return_policy: product_details_data.return_policy || "",
      });

      if (territoryData) {
        console.log("Territory Data:", territoryData);
        
        setExcludedTerritories(territoryData.territories || []);
        setIncludePincodes(territoryData.included_pincodes || []);
        setExcludePincodes(territoryData.excluded_pincodes || []);
      }

      if (product_details_data) {
        setSavedTitleTag(product_details_data.product_title || "");
        setSavedMetaDescription(product_details_data.product_description || "");
        setTitleTag(product_details_data.product_title || "");
        setMetaDescription(product_details_data.product_description || "");
      }

      setPsProductID(product_data.ps_product_ID);
      setPsProductProductcode(product_data.ps_product_productcode);
      setPsProductCat(product_data.ps_product_cat);
      setPsProductProductdesc(product_data.ps_product_productdesc);
      setPsProductProductimg(product_data.ps_product_productimg);
      setPsProductProdwho(product_data.ps_product_prodwho);
      setPsProductProdname(product_data.ps_product_prodname);
      // setPsProductDesc(product_data.ps_product_desc);
      setPsProductSellrate1(product_data.ps_product_sellrate1);
      setPsProductSellrate2(product_data.ps_product_sellrate2);
      setPsProductSellrate3(product_data.ps_product_sellrate3);
      setPsProductSubcat(product_data.ps_product_subcat);
      // setPsProductMill(product_details_data? product_details_data.manufacturing_details:product_data.ps_product_mill);
      setPsProductCount(product_data.ps_product_count);
      setPsProductComposition(product_data.ps_product_composition);
      setPsProductSize(product_data.ps_product_size);
      setPsProductConstruction(product_data.ps_product_construction);
      setPsProductWidth(product_data.ps_product_width);
      setPsProductStyle(product_data.ps_product_style);
      setPsProductQuality(product_data.ps_product_quality);
      setPsProductType(product_data.ps_product_type);
      setPsProductPattern(product_data.ps_product_pattern);
      setPsProductShade(product_data.ps_product_shade);
      setPsProductColor1(product_data.ps_product_color1);
      setPsProductColor2(product_data.ps_product_color2);
      setPsProductColor3(product_data.ps_product_color3);
      setPsProductColor4(product_data.ps_product_color4);
      setPsProductColor5(product_data.ps_product_color5);
      setPsProductPurchaserate1(product_data.ps_product_purchaserate1);
      setPsProductPurchaserate2(product_data.ps_product_purchaserate2);
      setPsProductPurchaserate3(product_data.ps_product_purchaserate3);
      setPsProductCreatedttime(product_data.ps_product_createdttime);
      setPsProductModifydttime(product_data.ps_product_modifydttime);
      setPsProductQQH(product_data.ps_product_QQH);
      setPsProductSO(product_data.ps_product_SO);
      setPsProductIQ(product_data.ps_product_IQ);
      setPsProductDC(product_data.ps_product_DC);
      setPsProductDCvalue(product_data.ps_product_DCvalue);
      setPsProductDCqty(product_data.ps_product_DCqty);
      setPsProductRcptqty(product_data.ps_product_rcptqty);
      setPsProductIssueqty(product_data.ps_product_issueqty);
      setPsProductLastsellrate(product_data.ps_product_lastsellrate);
      setPsProductCOMM(product_data.ps_product_COMM);
      setPsProductNetqty(product_data.ps_product_netqty);
      setPsProductDim1(product_data.ps_product_dim1);
      setPsProductDim2(product_data.ps_product_dim2);
      setPsProductDim3(product_data.ps_product_dim3);
      setPsProductDim4(product_data.ps_product_dim4);
      setPsProductDim5(product_data.ps_product_dim5);
      setPsProductInstock(product_data.ps_product_instock);
      setPsProductLikes(product_data.ps_product_likes);
      setPsProductTags(product_data.ps_product_tags);
      setPsProductTags2(product_data.ps_product_tags2);
      setPsProductExcelpath(product_data.ps_product_excelpath);
      setPsProductIsimgdone(product_data.ps_product_isimgdone);
      setPsProductTags3(product_data.ps_product_tags3);
      setProductCode(product_data.product_code);
      setIsNos(product_details_data ? product_details_data.is_nos : product_data.is_nos);
      setDenim(product_details_data ? product_details_data.denim : product_data.denim);
      setMinimumOrder(product_data.minimum_order);
      setTagIds(product_details_data ? product_details_data.tag_ids : product_data.tag_ids);
      setFabricSpecification(product_data.fabric_specification);
      // setDeliveryReturnPolicy(product_details_data ? {
      //   policy_type: product_details_data.return_policy?.policy_type || "manual",
      //   shipping_details: product_details_data.shipping_details?.shipping_details || "",
      //   return_policy: product_details_data.return_policy || "",
      // } : {});
      console.log("Delivery Return Policy:", delivery_return_policy);
      
      setProductDescription(product_data.product_description);
      setProductTitle(product_data.product_title);
      setFebricWeave(product_details_data ? product_details_data.fabric_weave : product_data.febricWeave);
      setProductDetailId(product_details_data ? product_details_data.id : "");
      setPatternSize(product_data.patternSize);
      setIsSpecChecked(product_data.isSpecChecked);
      setFabricSpec(product_data.fabricSpec);
      setEditedSpec(product_data.editedSpec);
      setManufacturingDetails(
        product_details_data
          ? product_details_data.manufacturing_details
            ? product_details_data.manufacturing_details
            : product_data.ps_product_mill
          : product_data.ps_product_mill
      );
      setEditedManufacturing(product_data.editedManufacturing);
      setIsTestChecked(product_data.isTestChecked);
      // setReports(
      //   product_data
      //     ? product_data.reports
      //       ? product_data.reports
      //       : reports
      //     : reports
      // );
      setIsChecked(product_data.isChecked);
      setIsStocked(product_data.isStocked);
      setFabricWeave(
        product_details_data
          ? product_details_data.fabric_weave
          : product_data.fabricWeave
      );
      setMinOrderQty(
        product_details_data
          ? product_details_data.minimum_order
          : product_data.minOrderQty
      );
      setIsCotton(product_data.isCotton);
      setTitleTag(
        product_details_data
          ? product_details_data.product_title
          : product_data.titleTag
      );
      setMetaDescription(
        product_details_data
          ? product_details_data.product_description
          : product_data.metaDescription
      );
    } else {
      console.error("Error fetching product data:", resData.message);
    }
    let weaveListData = await getData("/api/product/get-weaves");
    console.log(weaveListData["data"]["weave_tags"]);

    if (weaveListData["data"]["code"] === 200) {
      setWeaveList(weaveListData["data"]["weave_tags"]);
    } else {
      console.error("Error fetching weave list:", weaveListData.message);
    }

    let classificationListData = await getData("/api/product/get-fabric-classification");
    console.log(classificationListData["data"]["classification_tags"]);

    if (classificationListData["data"]["code"] === 200) {
      setClassificationList(classificationListData["data"]["classification_tags"]);
    } else {
      console.error("Error fetching classification list:", classificationListData.message);
    }
    setLoading(false);
  }

  useEffect(() => {
    fetchformData();
  }, [productId]);

  // Fetch saved similar products for the current productId
  useEffect(() => {
    // Only fetch if ps_product_ID is available (i.e., after product data is loaded)
    if (!ps_product_ID) return;
    async function fetchSimilarProducts() {
      try {
        const res = await getData(
          `/api/product/similar-product/?product_id=${ps_product_ID}`
        );
        if (
          res &&
          res["data"] &&
          Array.isArray(res["data"]["similar_product_ids"])
        ) {
          setSimilarProducts(res["data"]["similar_product_ids"]);
        } else {
          setSimilarProducts([]);
        }
      } catch (err) {
        setSimilarProducts([]);
      }
    }
    fetchSimilarProducts();
  }, [ps_product_ID]);

  // Fetch all products for search/autocomplete
  useEffect(() => {
    async function fetchAllProducts() {
      try {
        const res = await getData("/api/product/get-all-product");
        console.log("Fetched all products:", res); // Debug log
        if (res && res["data"] && res["data"]["live_products"]) {
          console.log("Fetched live_products:", res["data"]["live_products"]); // Debug log
          setAllProducts(res["data"]["live_products"]);
        } else {
          setAllProducts([]);
        }
      } catch (err) {
        console.error("Error fetching all products:", err);
        setAllProducts([]);
      }
    }
    fetchAllProducts();
  }, []);

  const [isChecked, setIsChecked] = useState(false);

  const toggleCheck = () => {
    setIsChecked((prev) => !prev);
  };

  const handleDeliveryInputChange = (e, field) => {
    setInputValues({ ...inputValues, [field]: e.target.value });
  };


  // Fetch pincode range for a single territory
  const fetchPincodeRange = async (territoryName) => {
    try {
      const response = await fetch(`https://api.postalpincode.in/postoffice/${territoryName}`);
      const data = await response.json();

      if (data[0]?.Status === "Success" && data[0]?.PostOffice?.length > 0) {
        const pincodes = data[0].PostOffice.map((office) => office.Pincode).sort();
        return pincodes.length > 0 ? `${pincodes[0]} to ${pincodes[pincodes.length - 1]}` : "";
      }
      return "";
    } catch (error) {
      console.error("Error fetching pincodes:", error);
      return "";
    }
  };

  const handleTerritoryInputChange = async (id, value) => {
    const updatedInputs = territoryInputs.map((input) =>
      input.id === id ? { ...input, value, pincodeRange: "" } : input
    );

    setTerritoryInputs(updatedInputs);

    setTimeout(async () => {
      if (value.length > 2) {
        const range = await fetchPincodeRange(value);
        setTerritoryInputs((prev) =>
          prev.map((input) =>
            input.id === id ? { ...input, pincodeRange: range } : input
          )
        );
      }
    }, 500);
  };

  const handleAddTerritories = () => {
    // Check if any selected territory does not have pincodeRange yet
    const waitingInputs = territoryInputs.filter(
      (input) => input.value.trim() && !input.pincodeRange
    );
    if (waitingInputs.length > 0) {
      setAddTerritoryError("Wait for pincode generation before adding");
      setTimeout(() => setAddTerritoryError(""), 2000);
      return;
    }
    setAddTerritoryError("");
    const newTerritories = territoryInputs
      .filter((input) => input.value.trim() && input.pincodeRange)
      .map((input) => input.value.trim());

    setExcludedTerritories((prev) => [
      ...new Set([...prev, ...newTerritories]),
    ]);
    setTerritoryInputs([
      { id: 1, value: "", pincodeRange: "" }
    ]);
  };

  const handleAddTag = async (field) => {
    const value = inputValues[field].trim();
    if (!value) return;

    try {
      let processedValue = value;

      if (field === "excluded") {
        // Fetch pincode details for excluded territories
        processedValue = await fetchPincodeRange(value);
      } else {
        // Validate numeric pincode for include/exclude
        if (!/^\d+$/.test(value)) {
          alert("Please enter a valid numeric pincode");
          return;
        }
      }

      const updateState = {
        excluded: () =>
          setExcludedTerritories([...excludedTerritories, processedValue]),
        include: () => setIncludePincodes([...includePincodes, processedValue]),
        exclude: () => setExcludePincodes([...excludePincodes, processedValue]),
      };

      updateState[field]();
      setInputValues({ ...inputValues, [field]: "" });
    } catch (error) {
      console.error("Error adding tag:", error);
    }
  };

  // Remove tags
  const handleRemoveTag = (field, index) => {
    if (field === "excluded")
      setExcludedTerritories(excludedTerritories.filter((_, i) => i !== index));
    else if (field === "include")
      setIncludePincodes(includePincodes.filter((_, i) => i !== index));
    else if (field === "exclude")
      setExcludePincodes(excludePincodes.filter((_, i) => i !== index));
  };

  // Fabric Testing Report function
  const handleTestFileChange = (index, target) => {
    if (!target || !target.files || !target.files[0]) {
      console.error("Invalid file input");
      return;
    }
    const file = target.files[0];
    if (
      file &&
      file.type === "application/pdf" &&
      file.size <= 5 * 1024 * 1024
    ) {
      setReports((prev) => {
        const updatedReports = [...prev];
        updatedReports[index] = {
          ...updatedReports[index],
          file: file,
          fileName: file.name,
          isNewUpload: true,
        };
        return updatedReports;
      });
    } else {
      alert("Only PDFs up to 5MB are allowed.");
    }
  };

  const handleTestDownload = (index) => {
    const report = reports[index];
    // If file is a File object (just uploaded, not reloaded)
    if (report.file instanceof File) {
      const url = URL.createObjectURL(report.file);
      const a = document.createElement("a");
      a.href = url;
      a.download = report.file.name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } else if (report.report_url) {
      // If file is a backend URL (after reload)
      const a = document.createElement("a");
      a.href = report.report_url;
      a.download = report.report_name || `report_${index + 1}.pdf`;
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } else {
      alert("No file uploaded or available to download.");
    }
  };

  const handleTestNameChange = (index, event) => {
    const name = event.target.value;
    setReports((prev) => {
      const updatedReports = [...prev];
      updatedReports[index] = {
        ...updatedReports[index],
        name: name,
      };
      return updatedReports;
    });
  };

  const addNewTestReport = () => {
    setReports((prev) => [
      ...prev,
      { id: prev.length + 1, name: "", file: null },
    ]);
  };

  const handleStockToggle = () => {
    setIsStocked((prev) => {
      const newValue = !prev;
      setIsNos(newValue ? 0 : 1);
      return newValue;
    });
  };

  return (
    <Box
      sx={{
        padding: 0,
        width: "100%",
        margin: "0 auto",
        fontFamily: "Inter, sans-serif",
      }}
    >
      {/* Dropdowns */}
      <Accordion sx={{ backgroundColor: "#F3F4F6", boxShadow: 0 }}>
        <AccordionSummary
          sx={{ display: "flex", alignItems: "center", gap: 2, height: 58 }}
        >
          <Typography
            variant="h7"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              fontWeight: "bold",
              mr: 4,
            }}
          >
            Important Fabric Details
          </Typography>
          {/* Expand icon just right of text */}
          <ExpandMoreIcon />
          {/* Check icon at far right, absolutely positioned */}
          <span
            style={{
              position: "absolute",
              right: 16,
              top: "50%",
              transform: "translateY(-50%)",
              pointerEvents: "auto",
              cursor: "pointer",
            }}
          >
            {isFabricDetailsSaved ? (
              <CheckCircleIcon sx={{ color: "#565E6D" }} />
            ) : (
              <RadioButtonUncheckedIcon />
            )}
          </span>
        </AccordionSummary>
        <AccordionDetails>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              gap: 30,
              padding: 30,
              paddingTop: 0,
              paddingBottom: 5,
            }}
          >
            {/* Column 1 */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                gap: 15,
              }}
            >
              <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                Fabric Classification: {fabricWeave}
              </Typography>
              <Select
                value={fabricWeave}
                onChange={(e) => setFabricWeave(e.target.value)}
                sx={{
                  width: 200,
                  height: 30,
                  borderRadius: "0px",
                  backgroundColor: "white",
                }}
              >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {classificationList.map((classification) => (
                    <MenuItem
                      key={classification.id}
                      value={classification.product_tag}
                      selected={classification.product_tag === fabricWeave}
                    >
                      {classification.product_tag}
                    </MenuItem>
                  ))}
              </Select>
              {/* <Button
                startIcon={<AddCircleOutlineIcon />}
                sx={{
                  mt: 4.5,
                  width: 200,
                  height: 28,
                  border: "1px solid #ccc", 
                  borderRadius: "0px",
                  backgroundColor: "white",
                  color: "black",
                  fontWeight: "bold",
                  "&:hover": { backgroundColor: "#b1b4b6" },
                }}
              >
                Create New
              </Button> */}
            </div>

           {/* Column 2 */}
                  <div
                    style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                    gap: 15,
                    }}
                  >
                    <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                    Never Out of Stock
                    </Typography>
                    <Box display="flex" alignItems="center" gap={1} sx={{ ml: 2 }}>
                    <Typography>No</Typography>
                    <Switch
                      checked={is_nos}
                      onChange={handleStockToggle}
                      sx={{
                      width: 40,
                      height: 24,
                      padding: 0,
                      "& .MuiSwitch-switchBase": {
                        "&.Mui-checked": {
                        transform: "translateX(10px)",
                        "& + .MuiSwitch-track": {
                          backgroundColor: "black",
                          opacity: 1,
                        },
                        },
                        "&:not(.Mui-checked)": {
                        transform: "translateX(-7px)",
                        },
                      },
                      "& .MuiSwitch-thumb": {
                        backgroundColor: "white",
                        width: 18,
                        height: 18,
                        marginTop: "-6px",
                      },
                      "& .MuiSwitch-track": {
                        backgroundColor: "black",
                        borderRadius: 20,
                      },
                      }}
                    />
                    <Typography>Yes</Typography>
                    </Box>
                    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                    <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                      Minimum Order Quantity
                    </Typography>
                    <input
                      type="number"
                      value={minOrderQty}
                      min={0}
                      onChange={(e) => {
                      const val = Math.max(0, Number(e.target.value));
                      setMinOrderQty(val);
                      }}
                      style={{
                      width: 180,
                      height: 30,
                      border: "1px solid #ccc",
                      borderRadius: "0px",
                      backgroundColor: "white",
                      }}
                    />
                    </div>
                  </div>
                  <div
                    style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                    gap: 15,
                    }}
                  >
                    <FormControlLabel
                    control={
                      <Checkbox
                      checked={denim}
                      onChange={(e) => setDenim(e.target.checked)}
                      sx={{
                        color: "#565E6D",
                        "&.Mui-checked": {
                        color: "#565E6D",
                        },
                        "& .MuiSvgIcon-root": {
                        fontSize: 22,
                        },
                      }}
                      />
                    }
                    label="Denim"
                    />
                    {/* Save Changes Button */}
              <div style={{ textAlign: "center", marginTop: "50px" }}>
                <Button
                  sx={{
                    backgroundColor: "#565E6D",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#546e7a" },
                    borderRadius: "0px",
                  }}
                  onClick={handleSubmit}
                >
                  Save Changes
                </Button>
              </div>
            </div>
          </div>
        </AccordionDetails>
      </Accordion>

      {/* Add Fabric Tag Section */}
      <AddFabricTag onTagsSaved={fetchMetaTags} />

      {/* Fabric specification */}
      <Accordion sx={{ mt: 2, backgroundColor: "#F3F4F6", boxShadow: 0 }}>
        <AccordionSummary
          sx={{ display: "flex", alignItems: "center", gap: 2, height: 58 }}
        >
          <Typography
            variant="h7"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              fontWeight: "bold",
              mr: 8,
            }}
          >
            Fabric Specification
          </Typography>
          {/* Expand icon just right of text */}
          <ExpandMoreIcon />
          {/* Check icon at far right, absolutely positioned */}
          <span
            style={{
              position: "absolute",
              right: 16,
              top: "50%",
              transform: "translateY(-50%)",
              pointerEvents: "auto",
              cursor: "pointer",
            }}
          >
            {isFabricSpecSaved ? (
              <CheckCircleIcon sx={{ color: "#565E6D" }} />
            ) : (
              <RadioButtonUncheckedIcon />
            )}
          </span>
        </AccordionSummary>
        <AccordionDetails>
          <div style={{ marginTop: "5px", padding: "10px", paddingTop: "0px" }}>
            <Typography variant="h7" sx={{ fontWeight: "bold" }}>
              Fabric specifications
            </Typography>
            <TextField
              placeholder="Auto generated"
              multiline
              fullWidth
              rows={8}
              variant="outlined"
              sx={{
                marginTop: "10px",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "0px",
                  backgroundColor: "white",
                },
              }}
              value={editedSpec ? editedSpec : savedFabricSpec}
              onChange={(event) => setEditedSpec(event.target.value)}
            />

            {/* Save Changes Button */}
            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <Button
                sx={{
                  backgroundColor: "#565E6D",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#546e7a" },
                  borderRadius: "0px",
                }}
                onClick={handleFabricSpecSubmit}
              >
                Save Changes
              </Button>
            </div>

            {/* Display Saved Fabric Specification */}
            {/* {savedFabricSpec && (
              <div style={{ marginTop: "20px" }}>
                <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                  Saved Fabric Specification:
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ marginTop: "10px", whiteSpace: "pre-wrap" }}
                >
                  {savedFabricSpec}
                </Typography>
              </div>
            )} */}
          </div>
        </AccordionDetails>
      </Accordion>

      {/* Manufacturing details */}
      <Accordion sx={{ mt: 2, backgroundColor: "#F3F4F6", boxShadow: 0 }}>
        <AccordionSummary
          sx={{ display: "flex", alignItems: "center", gap: 2, height: 58 }}
        >
          <Typography
            variant="h7"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              fontWeight: "bold",
              mr: 6,
            }}
          >
            Manufacturing details
          </Typography>
          {/* Expand icon just right of text */}
          <ExpandMoreIcon />
          {/* Check icon at far right, absolutely positioned */}
          <span
            style={{
              position: "absolute",
              right: 16,
              top: "50%",
              transform: "translateY(-50%)",
              pointerEvents: "auto",
              cursor: "pointer",
            }}
          >
            {isManufacturingDetailsSaved ? (
              <CheckCircleIcon sx={{ color: "#565E6D" }} />
            ) : (
              <RadioButtonUncheckedIcon />
            )}
          </span>
        </AccordionSummary>
        <AccordionDetails>
          <div style={{ marginTop: "5px", padding: "10px", paddingTop: "0px" }}>
            <Typography variant="h7" sx={{ fontWeight: "bold" }}>
              Manufacturing details
            </Typography>
            <TextField
              placeholder="manual"
              multiline
              fullWidth
              rows={8}
              variant="outlined"
              sx={{
                marginTop: "10px",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "0px",
                  backgroundColor: "white",
                },
              }}
              value={manufacturingDetails}
              onChange={(event) => setManufacturingDetails(event.target.value)}
            />

            {/* Save Changes Button */}
            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <Button
                sx={{
                  backgroundColor: "#565E6D",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#546e7a" },
                  borderRadius: "0px",
                }}
                onClick={handleManufacturingDetailsSubmit}
              >
                Save Changes
              </Button>
            </div>

            {/* Display Saved Manufacturing Details */}
            {savedManufacturingDetails && (
              <div style={{ marginTop: "20px" }}>
                <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                  Saved Manufacturing Details:
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ marginTop: "10px", whiteSpace: "pre-wrap" }}
                >
                  {savedManufacturingDetails}
                </Typography>
              </div>
            )}
          </div>
        </AccordionDetails>
      </Accordion>

      {/* Similar products */}
      <Accordion sx={{ mt: 2, backgroundColor: "#F3F4F6", boxShadow: 0 }}>
        <AccordionSummary
          sx={{ display: "flex", alignItems: "center", gap: 2, height: 58 }}
        >
          <Typography
            variant="h7"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              fontWeight: "bold",
              mr: 11.5,
            }}
          >
            Similar products
          </Typography>
          {/* Expand icon just right of text */}
          <ExpandMoreIcon />
          {/* Check icon at far right, absolutely positioned */}
          <span
            style={{
              position: "absolute",
              right: 16,
              top: "50%",
              transform: "translateY(-50%)",
              pointerEvents: "auto",
              cursor: "pointer",
            }}
          >
            {isSimilarProductsSaved ? (
              <CheckCircleIcon sx={{ color: "#565E6D" }} />
            ) : (
              <RadioButtonUncheckedIcon />
            )}
          </span>
        </AccordionSummary>
        <AccordionDetails>
          {console.log(
            "Similar Products Section - Current Product ID:",
            ps_product_ID
          )}
          {console.log(
            "Similar Products Section - Saved Similar Products:",
            similarProducts
          )}
          <div
            style={{
              marginTop: "5px",
              padding: "10px",
              paddingTop: "0px",
              display: "flex",
              flexDirection: "column",
              gap: 20,
            }}
          >
            {/* Multi-select for similar products */}
            <Autocomplete
              multiple
              options={allProducts.filter((p) => p.product_id !== productId)}
              getOptionLabel={(option) =>
                option.ps_product_prodname ||
                option.ps_product_productcode ||
                option.ps_product_ID?.toString() ||
                ""
              }
              isOptionEqualToValue={(option, value) =>
                option.ps_product_ID === value.ps_product_ID
              }
              value={allProducts.filter((p) =>
                similarProducts.includes(p.ps_product_ID)
              )}
              onChange={(event, newValue) => {
                setSimilarProducts(newValue.map((p) => p.ps_product_ID));
              }}
              sx={{
                width: "100%",
                mb: 2,
                "& .MuiOutlinedInput-root": {
                  borderRadius: "0px",
                  backgroundColor: "white",
                },
                "& .MuiAutocomplete-popper": { borderRadius: "0px" },
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Similar Products"
                  variant="outlined"
                  sx={{
                    borderRadius: "0px",
                    minHeight: 36,
                    height: 36,
                    fontSize: 14,
                    width: "100%",
                    backgroundColor: "white",
                  }}
                />
              )}
            />
            {/* Display fetched similar products */}
            <Box sx={{ mb: 2 }}>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: "bold", mb: 1 }}
              >
                Similar Products :
              </Typography>
              {similarProducts.length === 0 ? (
                <Typography variant="body2" sx={{ color: "#888" }}>
                  No similar products found.
                </Typography>
              ) : (
                <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
                  {allProducts
                    .filter((p) => similarProducts.includes(p.ps_product_ID))
                    .map((product) => (
                      <Box
                        key={product.ps_product_ID}
                        sx={{
                          border: "1px solid #BCC1CA",
                          borderRadius: 2,
                          p: 2,
                          minWidth: 180,
                          background: "#fff",
                          alignItems: "center",
                          textAlign: "center",
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          sx={{ fontWeight: "bold" }}
                        >
                          {product.ps_product_prodname ||
                            product.ps_product_productcode ||
                            product.ps_product_ID}
                        </Typography>
                        <Typography variant="caption" sx={{ color: "#BCC1CA" }}>
                          Product ID: {product.ps_product_ID}
                        </Typography>
                      </Box>
                    ))}
                </div>
              )}
            </Box>
            <Button
              variant="contained"
              sx={{
                width: 170,
                borderRadius: 0,
                backgroundColor: "#565E6D",
                color: "#fff",
                mb: 0,
                alignSelf: "center",
                "&:hover": { backgroundColor: "#546e7a" },
              }}
              onClick={async () => {
                if (!ps_product_ID || !similarProducts.length) return;
                setLoading(true);
                try {
                  const res = await postData("/api/product/similar-product/", {
                    'product_id': ps_product_ID, // Use the actual product ID
                    'similar_product_ids': similarProducts,
                  });
                  if (res && res["data"] && res["data"]["code"] === "200") {
                    alert("Similar products saved!");
                    setIsSimilarProductsSaved(true);
                    console.log(res["data"]["message"]);
                  } else {
                    alert("Failed to save similar products.");
                    setIsSimilarProductsSaved(false);
                  }
                } catch (err) {
                  alert("Error saving similar products.");
                  setIsSimilarProductsSaved(false);
                } finally {
                  setLoading(false);
                }
              }}
            >
              Save Changes
            </Button>
          </div>
        </AccordionDetails>
      </Accordion>

      {/* Fabric Testing Report Section */}
      <Accordion sx={{ mt: 2, backgroundColor: "#F3F4F6", boxShadow: 0 }}>
        <AccordionSummary
          sx={{ display: "flex", alignItems: "center", gap: 2, height: 58 }}
        >
          <Typography variant="h7" sx={{ fontWeight: "bold", mr: 6.5 }}>
            Fabric Testing Report
          </Typography>
          {/* Expand icon */}
          <ExpandMoreIcon />
          {/* Check icon */}
          <span
            style={{
              position: "absolute",
              right: 16,
              top: "50%",
              transform: "translateY(-50%)",
              pointerEvents: "auto", // allow click if you want
              cursor: "pointer",
            }}
          >
            {isTestReportSaved ? (
              <CheckCircleIcon sx={{ color: "#565E6D" }} />
            ) : (
              <RadioButtonUncheckedIcon />
            )}
          </span>
        </AccordionSummary>
        <AccordionDetails sx={{ padding: "25px", pt: 2 }}>
          {reports.map((report, index) => (
            <div key={index} style={{ marginBottom: "10px" }}>
              <Typography variant="body2" fontWeight="bold">
                Fabric testing report {index + 1}
              </Typography>
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <TextField
                  variant="outlined"
                  placeholder="Name of the report"
                  sx={{
                    width: "350px",
                    "& .MuiOutlinedInput-root": {
                      height: "35px",
                      borderRadius: "0px",
                      backgroundColor: "white",
                    },
                  }}
                  value={report.report_name}
                  onChange={(e) => handleTestNameChange(index, e)}
                />
                <Button component="label" style={{ color: "black" }}>
                  <FileUploadOutlinedIcon sx={{ mr: 1 }} /> Upload
                  <input
                    onChange={(e) => handleTestFileChange(index, e.target)}
                    type="file"
                    hidden
                    accept="application/pdf"
                  />
                </Button>
                <Button
                  component="button"
                  onClick={() => handleTestDownload(index)}
                  style={{ color: "black" }}
                >
                  <FileDownloadOutlinedIcon sx={{ mr: 1 }} /> Download
                </Button>
              </div>
              {report.report_url && (
                <Typography variant="body2" sx={{ color: "green" }}>
                  {report.report_name}
                </Typography>
              )}
              <Typography variant="caption" color="textSecondary">
                Only PDFs. Maximum file size 5MB
              </Typography>
            </div>
          ))}
          <Button
            startIcon={<AddCircleOutlineIcon />}
            sx={{ mt: 0, backgroundColor: "transparent", color: "black" }}
            onClick={addNewTestReport}
          >
            Add new report
          </Button>
          {/* Save Changes Button */}
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <Button
              sx={{
                backgroundColor: "#565E6D",
                color: "#fff",
                "&:hover": { backgroundColor: "#546e7a" },
                borderRadius: "0px",
              }}
              onClick={handleTestReportSubmit}
            >
              Save Changes
            </Button>
          </div>
        </AccordionDetails>
      </Accordion>

      {/* Delivery & Return Policy Section */}
      <Accordion sx={{ mt: 2, backgroundColor: "#F3F4F6", boxShadow: 0 }}>
        <AccordionSummary
          sx={{ display: "flex", alignItems: "center", gap: 2, height: 58 }}
        >
          <Typography variant="h7" sx={{ fontWeight: "bold", mr: 14.5 }}>
            Return Policy
          </Typography>
          {/* Expand icon */}
          <ExpandMoreIcon />
          {/* Check icon */}
          <span
            style={{
              position: "absolute",
              right: 16,
              top: "50%",
              transform: "translateY(-50%)",
              pointerEvents: "auto", // allow click if you want
              cursor: "pointer",
            }}
          >
            {isDeliveryPolicySaved ? (
              <CheckCircleIcon sx={{ color: "#565E6D" }} />
            ) : (
              <RadioButtonUncheckedIcon />
            )}
          </span>
        </AccordionSummary>
        <AccordionDetails sx={{ padding: "25px", pt: 0 }}>
          <FormControl component="fieldset" sx={{ mt: 0 }}>
            <RadioGroup
              row
              value={
                (delivery_return_policy &&
                  delivery_return_policy.policy_type) ||
                "manual"
              }
              onChange={(e) =>
                setDeliveryReturnPolicy((prev) => ({
                  ...(prev || { shipping_details: "", return_policy: "" }),
                  policy_type: e.target.value,
                }))
              }
            >
              <FormControlLabel
                value="stored"
                control={
                  <Radio
                    sx={{
                      color: "black",
                      "&.Mui-checked": { color: "black" },
                    }}
                  />
                } // Added closing /> here
                label="Add stored data"
              />
              <FormControlLabel
                value="manual"
                control={
                  <Radio
                    sx={{
                      color: "black",
                      "&.Mui-checked": { color: "black" },
                    }}
                  />
                }
                label="Manual input"
              />
            </RadioGroup>
          </FormControl>

          <div style={{ display: "flex", gap: "20px", marginTop: "10px" }}>
            <div style={{ flex: 1 }}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Add specific shipping details
              </Typography>
              <TextField
                placeholder="Write shipping details"
                multiline
                fullWidth
                rows={4}
                variant="outlined"
                value={(delivery_return_policy?delivery_return_policy.shipping_details:'') || ""}
                onChange={(e) =>
                  setDeliveryReturnPolicy((prev) => ({
                    ...prev,
                    shipping_details: e.target.value,
                  }))
                }
                sx={{
                  marginTop: "10px",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "0px",
                    backgroundColor: "white",
                  },
                }}
              />
            </div>

            <div style={{ flex: 1 }}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Add specific Return policy
              </Typography>
              <TextField
                placeholder="Write return policy"
                multiline
                fullWidth
                rows={4}
                variant="outlined"
                value={(delivery_return_policy?delivery_return_policy.return_policy:'') || ""}
                onChange={(e) =>
                  setDeliveryReturnPolicy((prev) => ({
                    ...prev,
                    return_policy: e.target.value,
                  }))
                }
                sx={{
                  marginTop: "10px",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "0px",
                    backgroundColor: "white",
                  },
                }}
              />
            </div>
          </div>

          {/* Save Changes Button */}
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <Button
              sx={{
                backgroundColor: "#565E6D",
                color: "#fff",
                "&:hover": { backgroundColor: "#546e7a" },
                borderRadius: "0px",
                mt: 2,
              }}
              onClick={handleDeliveryPolicySubmit}
            >
              Save Changes
            </Button>
          </div>

          {/* Display Saved Policies */}
          {(delivery_return_policy?delivery_return_policy.shipping_details:"") &&
            (delivery_return_policy?delivery_return_policy.return_policy:"") && (
              <div style={{ marginTop: "20px" }}>
                {/* <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                Policy Type: {delivery_return_policy.policy_type === 'stored' ? 'Stored Data' : 'Manual Input'}
              </Typography>  */}
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                      Shipping Details:
                    </Typography>
                    <Typography variant="body1">
                      {delivery_return_policy?delivery_return_policy.shipping_details:''}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                      Return Policy:
                    </Typography>
                    <Typography variant="body1">
                      {delivery_return_policy.return_policy}
                    </Typography>
                  </Grid>
                </Grid>
              </div>
            )}
        </AccordionDetails>
      </Accordion>

      {/* Delivery Details Section */}
      <Accordion sx={{ mt: 2, backgroundColor: "#F3F4F6", boxShadow: 0 }}>
        <AccordionSummary
          sx={{ display: "flex", alignItems: "center", gap: 2, height: 58 }}
        >
          <Typography
            variant="h7"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              fontWeight: "bold",
              mr: 12,
            }}
          >
            Delivery Details
          </Typography>
          {/* Expand icon */}
          <ExpandMoreIcon />
          {/* Check icon */}
          <span
            style={{
              position: "absolute",
              right: 16,
              top: "50%",
              transform: "translateY(-50%)",
              pointerEvents: "auto",
              cursor: "pointer",
            }}
          >
            {isDeliveryDetailsSaved ? (
              <CheckCircleIcon sx={{ color: "#565E6D" }} />
            ) : (
              <RadioButtonUncheckedIcon />
            )}
          </span>
        </AccordionSummary>
        <AccordionDetails>
          {/* Two-Column Layout */}
          <div
            style={{
              display: "flex",
              gap: "40px",
              padding: "10px",
              paddingTop: "0px",
            }}
          >
            {/* Left Section - Inputs */}
            <div style={{ flex: 1 }}>
              <Typography variant="body1" fontWeight="bold" sx={{ mb: 4 }}>
                Excluded territories for shipping
              </Typography>
              <Typography variant="body2" fontWeight="bold" sx={{ mb: 1 }}>
                Excluded Territories
              </Typography>

              {territoryInputs.map((input) => (
                <div key={input.id} style={{ marginBottom: "10px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <Autocomplete
                      options={indianStates}
                      value={input.value}
                      onChange={(_, newValue) => handleTerritoryInputChange(input.id, newValue || "")}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          placeholder="Select state"
                          sx={{
                            width: "350px",
                            mb: 1,
                            "& .MuiOutlinedInput-root": {
                              height: "36px",
                              borderRadius: "0px",
                              backgroundColor: "white",
                            },
                          }}
                        />
                      )}
                    />
                    <Button
                      startIcon={<AddCircleOutlineIcon />}
                      onClick={handleAddTerritories}
                      sx={{
                        ml: -0.7,
                        mb: 1,
                        backgroundColor: "transparent",
                        color: "black",
                        minWidth: 80
                      }}
                    >
                      Add
                    </Button>
                  </div>
                  {addTerritoryError && (
                    <Typography color="error" sx={{ mt: 1, fontSize: "0.9rem" }}>
                      {addTerritoryError}
                    </Typography>
                  )}
                  {input.pincodeRange && (
                    <Typography
                      variant="caption"
                      sx={{
                        display: "block",
                        mt: 1,
                        color: "#666",
                        fontSize: "0.8rem",
                      }}
                    >
                      Pincode range: {input.pincodeRange}
                    </Typography>
                  )}
                </div>
              ))}
              <Typography variant="body2" fontWeight="bold" sx={{ mb: 1 }}>
                Include specific pincodes for delivery
              </Typography>
              <TextField
                variant="outlined"
                sx={{
                  width: "350px",
                  mb: 1,
                  "& .MuiOutlinedInput-root": {
                    height: "36px",
                    borderRadius: "0px",
                    backgroundColor: "white",
                  },
                }}
                value={inputValues.include}
                onChange={(e) => handleDeliveryInputChange(e, "include")}
                placeholder="Enter pincode to include"
                inputProps={{
                  maxLength: 6,
                  pattern: "\\d*",
                  inputMode: "numeric",
                }}
              />
              <Button
                startIcon={<AddCircleOutlineIcon />}
                sx={{
                  ml: 1,
                  mb: 1,
                  backgroundColor: "transparent",
                  color: "black",
                }}
                onClick={() => handleAddTag("include")}
              >
                Add 
              </Button>

              {/* Exclude Pincodes */}
              <Typography variant="body2" fontWeight="bold" sx={{ mb: 1 }}>
                Exclude specific pincodes for delivery
              </Typography>
              <TextField
                variant="outlined"
                sx={{
                  width: "350px",
                  mb: 1,
                  "& .MuiOutlinedInput-root": {
                    height: "36px",
                    borderRadius: "0px",
                    backgroundColor: "white",
                  },
                }}
                value={inputValues.exclude}
                onChange={(e) => handleDeliveryInputChange(e, "exclude")}
                placeholder="Enter pincode to exclude"
                inputProps={{
                  maxLength: 6,
                  pattern: "\\d*",
                  inputMode: "numeric",
                }}
              />
              <Button
                startIcon={<AddCircleOutlineIcon />}
                sx={{
                  ml: 1,
                  mb: 0,
                  backgroundColor: "transparent",
                  color: "black",
                }}
                onClick={() => handleAddTag("exclude")}
              >
                Add 
              </Button>
            </div>

            {/* Right Section - Tags */}
            <div style={{ width: "400px" }}>
              {/* Excluded Territories Tags */}
              <Typography
                variant="body2"
                fontWeight="bold"
                sx={{ mb: 2, mt: 4.5 }}
              >
                Excluded territories for shipping
              </Typography>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "10px",
                  marginBottom: "20px",
                }}
              >
                {excludedTerritories.map((territory, index) => (
                  <Chip
                    key={index}
                    label={territory}
                    onDelete={() =>
                      setExcludedTerritories((prev) =>
                        prev.filter((_, i) => i !== index)
                      )
                    }
                    sx={{
                      m: 0.5,
                      backgroundColor: "#565E6D",
                      color: "white",
                      "& .MuiChip-deleteIcon": { color: "white" },
                    }}
                  />
                ))}
              </div>

              {/* Included Pincodes Tags */}
              <Typography
                variant="body2"
                fontWeight="bold"
                sx={{ mb: 2, mt: 6 }}
              >
                Included regions for shipping
              </Typography>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "10px",
                  marginBottom: "20px",
                }}
              >
                {includePincodes.map((item, index) => (
                  <Chip
                    key={index}
                    label={item}
                    onDelete={() => handleRemoveTag("include", index)}
                    deleteIcon={<CancelIcon sx={{ color: "white" }} />}
                    sx={{
                      backgroundColor: "#565E6D",
                      color: "white",
                      "& .MuiChip-deleteIcon": { color: "white" },
                    }}
                  />
                ))}
              </div>

              {/* Excluded Pincodes Tags */}
              <Typography
                variant="body2"
                fontWeight="bold"
                sx={{ mb: 2, mt: 4.6 }}
              >
                Excluded regions for shipping
              </Typography>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                {excludePincodes.map((item, index) => (
                  <Chip
                    key={index}
                    label={item}
                    onDelete={() => handleRemoveTag("exclude", index)}
                    deleteIcon={<CancelIcon sx={{ color: "white" }} />}
                    sx={{
                      backgroundColor: "#565E6D",
                      mb: 2,
                      color: "white",
                      "& .MuiChip-deleteIcon": { color: "white" },
                    }}
                  />
                ))}
              </div>
            </div>
          </div>

          {/* Save Changes Button */}
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <Button
              sx={{
                backgroundColor: "#565E6D",
                color: "#fff",
                "&:hover": { backgroundColor: "#546e7a" },
                borderRadius: "0px",
              }}
              onClick={handleDeliveryDetailsSubmit}
            >
              Save Changes
            </Button>
          </div>
        </AccordionDetails>
      </Accordion>

      {/* Meta Tags & Description Section */}
      <Accordion sx={{ mt: 2, backgroundColor: "#F3F4F6", boxShadow: 0 }}>
        <AccordionSummary
          sx={{ display: "flex", alignItems: "center", gap: 2, height: 58 }}
        >
          <Typography
            variant="h7"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              fontWeight: "bold",
              mr: 3.5,
            }}
          >
            Meta Tags & Description
          </Typography>
          {/* Expand icon just right of text */}
          <ExpandMoreIcon />
          {/* Check icon at far right, absolutely positioned */}
          <span
            style={{
              position: "absolute",
              right: 16,
              top: "50%",
              transform: "translateY(-50%)",
              pointerEvents: "auto", // allow click if you want
              cursor: "pointer",
            }}
          >
            {isMetaTagsSaved ? (
              <CheckCircleIcon sx={{ color: "#565E6D" }} />
            ) : (
              <RadioButtonUncheckedIcon />
            )}
          </span>
        </AccordionSummary>
        <AccordionDetails>
          <div style={{ marginTop: "5px", padding: "10px", paddingTop: "0px" }}>
            {/* AI Generated Title Tags */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                marginBottom: "5px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                AI generated title tags
              </Typography>
              <Tooltip title="Based on the tag selected" placement="right">
                <InfoIcon
                  sx={{ fontSize: 16, color: "#565E6D", cursor: "pointer" }}
                />
              </Tooltip>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                marginBottom: "10px",
              }}
            >
              <TextField
                variant="outlined"
                placeholder="Enter AI-generated title tag"
                multiline
                minRows={2}
                maxRows={4}
                sx={{
                  width: "100%",
                  "& .MuiOutlinedInput-root": {
                    minHeight: "65px",
                    borderRadius: "0px",
                    backgroundColor: "white",
                  },
                }}
                value={titleTag}
                onChange={(e) => setTitleTag(e.target.value)}
                disabled={!isEditingTitle}
              />
              <IconButton onClick={() => setIsEditingTitle((prev) => !prev)}>
                <EditOutlinedIcon />
              </IconButton>
            </div>

            {/* Meta Descriptions */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "5px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                Meta Descriptions
              </Typography>
              <IconButton onClick={() => setIsEditingDescription((prev) => !prev)}>
                <EditOutlinedIcon />
              </IconButton>
            </div>
            <TextField
              variant="outlined"
              placeholder="Enter meta description"
              multiline
              minRows={4}
              sx={{
                width: "100%",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "0px",
                  backgroundColor: "white",
                },
              }}
              value={metaDescription}
              onChange={(e) => setMetaDescription(e.target.value)}
              disabled={!isEditingDescription}
            />

            {/* Save Changes Button */}
            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <Button
                sx={{
                  backgroundColor: "#fff",
                  color: "#565E6D",
                  border: "1px solid #565E6D",
                  "&:hover": { backgroundColor: "#565E6D", color: "#fff" },
                  borderRadius: "0px",
                  mr: 2
                }}
                onClick={handleSyncMeta}
                disabled={isGeneratingMeta}
              >
                {isGeneratingMeta ? "Generating..." : "Generate"}
              </Button>
              <Button
                sx={{
                  backgroundColor: "#565E6D",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#546e7a" },
                  borderRadius: "0px",
                }}
                onClick={handleMetaTagsSubmit}
              >
                Save Changes
              </Button>
            </div>

            {/* {savedTitleTag && savedMetaDescription && (
            <div style={{ marginTop: "20px" }}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Saved Meta Tags:
              </Typography>
              <Box sx={{ mt: 2, p: 2, backgroundColor: 'white', border: '1px solid #ddd' }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                  Title Tag:
                </Typography>
                <Typography variant="body1" sx={{ mt: 1, whiteSpace: 'pre-wrap' }}>
                  {savedTitleTag}
                </Typography>
                
                <Typography variant="subtitle1" sx={{ mt: 2, fontWeight: 'bold' }}>
                                   Meta Description:
                </Typography>
                <Typography variant="body1" sx={{ mt: 1, whiteSpace: 'pre-wrap' }}>
                  {savedMetaDescription}
                </Typography>
              </Box>
            </div>
          )} */}
          </div>
        </AccordionDetails>
      </Accordion>

      {/* <Button
        fullWidth
        sx={{
          mt: 5,
          padding: 1,
          borderRadius: "0px",
          backgroundColor: "#DEE1E6",
          color: "black",
          fontWeight: "bold",
          "&:hover": {
            backgroundColor: "#b1b4b6",
          },
        }}
      >
        Save properties as custom preset
      </Button> */}
    </Box>
  );
}
